"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _NotifyIcon = _interopRequireDefault(require("../NotifyIcon"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InfoIcon = exports.InfoIcon = (0, _styledComponents["default"])(_NotifyIcon["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #58BAAA !important;\n  font-size:1.8rem !important;\n  margin-left:7px;\n"])));